import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import {
  END_USER_RECIPES_ROUTE,
  END_USER_SHARED_PROGRAMMES_ROUTE,
} from '../../services/routes';
import {
  useGetEndUserSpaceQuery,
  useGetSharedProgrammesForEndUserQuery,
} from '../../app/smorgAppSyncGraphQLApiCustomHooks';

const MyDayLetsStartCardButton = () => {
  const navigate = useNavigate();

  const { data: currentSpace } = useGetEndUserSpaceQuery();

  const { data: sharedProgrammes } = useGetSharedProgrammesForEndUserQuery();

  const anyProgrammesAvailable =
    sharedProgrammes && sharedProgrammes.length > 0;

  const onClick = () => {
    navigate(
      !anyProgrammesAvailable
        ? END_USER_RECIPES_ROUTE
        : END_USER_SHARED_PROGRAMMES_ROUTE,
    );
  };

  const whiteLabelElements = currentSpace?.whiteLabelElements;
  const backgroundColor =
    whiteLabelElements?.cardBackgroundColor ||
    whiteLabelElements?.primaryMainColor;

  return (
    <Button
      onClick={onClick}
      variant="contained"
      size="medium"
      fullWidth
      disableElevation
      style={{
        width: '336px',
        margin: '16px 23px 0',
        borderRadius: '30px',
        padding: '16px 8px',
        backgroundColor,
      }}>
      Let&apos;s start
    </Button>
  );
};

export default MyDayLetsStartCardButton;
